import { Reveal, PageHero } from "@/components/shared";
import { CONTACT } from "@/lib/content";

const SECTIONS = [
  {
    title: "Who we are",
    body: "Elite Imperium Digital is the technology consultancy of Elite Imperium Corp & Group, based in Antigua and Barbuda. This policy explains what personal information we collect through this website, why we collect it, and the choices you have.",
  },
  {
    title: "What we collect",
    body: "When you use this site you may give us: your name, email address, phone number, business name and website address through our contact, consultation and audit request forms; your email address when you subscribe to The Caribbean Digital Dispatch; and the answers you provide in the digital audit questionnaire. Separately, Google Analytics records anonymised usage information such as pages visited and approximate location, using cookies.",
  },
  {
    title: "How we use it",
    body: "We use your details only to respond to your enquiry, prepare your audit report, deliver services you have asked for, and send the newsletter you subscribed to. Audit form answers are used solely to prepare your report and are not shared with third parties. We do not sell, rent or trade your personal information, ever.",
  },
  {
    title: "Cookies and analytics",
    body: "This site can use Google Analytics 4 (property G-JM260TF2KY) to count visits and understand which pages are read — but only after you press Accept on the cookie banner shown on your first visit. If you press Decline, no analytics cookies are set and no usage data is collected. You can change your choice anytime by clearing your browser's stored data for this site. We do not use advertising or ad-network tracking cookies.",
  },
  {
    title: "Who processes your data",
    body: "Your information is processed by a small number of trusted providers acting on our behalf: our website hosting platform, our managed email service (used to send notifications and your report), and Google Analytics. Each processes data only as needed to provide their service to us.",
  },
  {
    title: "How long we keep it",
    body: "Enquiry and audit records are kept while your engagement with us is active and for up to 24 months afterwards, then deleted. Newsletter subscriptions are kept until you unsubscribe — every email includes an unsubscribe option.",
  },
  {
    title: "Your rights",
    body: "Under the Antigua and Barbuda Data Protection Act 2013 — and, for UK and European visitors, the GDPR — you may ask to see the personal information we hold about you, have it corrected, or have it deleted. Email us at any time and we will respond within 14 days.",
  },
  {
    title: "Security",
    body: "This site is served over encrypted HTTPS connections. Form submissions are stored in an access-controlled database, and administrative access is protected by strong authentication. No website is perfectly secure, but we take proportionate care with what you entrust to us.",
  },
  {
    title: "Changes to this policy",
    body: "If we change this policy we will update this page and the date below. It was last updated in July 2026.",
  },
];

export default function Privacy() {
  return (
    <main data-testid="privacy-page">
      <PageHero
        eyebrow="Privacy & Cookies"
        title="Your information, handled with care."
        lead="The short, plain-English version of how we treat your data. If anything is unclear, ask — we answer personally."
      />
      <section className="pb-24 lg:pb-32">
        <div className="mx-auto max-w-3xl space-y-8 px-6 lg:px-10">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.04}>
              <div className="gold-ring-card p-8" data-testid={`privacy-section-${i}`}>
                <h2 className="font-serif text-2xl text-ivory">{s.title}</h2>
                <p className="mt-4 text-sm font-light leading-relaxed text-slate-300">{s.body}</p>
              </div>
            </Reveal>
          ))}
          <Reveal>
            <div className="rounded-2xl border border-gold/30 bg-gold/5 p-8" data-testid="privacy-contact">
              <h2 className="font-serif text-2xl text-ivory">Talk to us about your data</h2>
              <p className="mt-4 text-sm font-light leading-relaxed text-slate-300">
                Email {CONTACT.email} or call {CONTACT.phone} (Antigua) / {CONTACT.phone_uk} (UK). Our office is at {CONTACT.office}.
              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
